import React, { useState } from "react";
import { getMapComuneData } from "./MapUtils";
import { useTranslation } from "react-i18next";
import { Box, Button, CircularProgress } from "@material-ui/core";

export const UpdateMapButton = (props) => {
  const [mapUpdateLoading, setMapUpdateLoading] = useState(false);
  const { t } = useTranslation();

  const handleUpdateMap = async (props) => {
    setMapUpdateLoading(true);
    await getMapComuneData(props);
    setMapUpdateLoading(false);
  };

  return (
    <Box ml={1}>
      <Button variant="outlined" color="secondary" size="small" onClick={() => handleUpdateMap(props)}>
        {mapUpdateLoading && (
          <Box mr={1}>
            <CircularProgress size={12}></CircularProgress>
          </Box>
        )}

        {t("table.updateTheMap")}
      </Button>
    </Box>
  );
};
